import React, { useState } from 'react';
import { forgotPassword } from '../api/userApi';
import imageSchool from '../Images/Photo1.PNG';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await forgotPassword(email);

      // backend renvoie une STRING
      setMessage(
        response.data || "Email envoyé avec succès. Vérifiez votre boîte mail."
      );

      setEmail('');

    } catch (error) {
      setError(
        typeof error.response?.data === "string"
          ? error.response.data
          : error.response?.data?.message ||
            "Erreur lors de l'envoi du lien."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="custom-container">
      <div className="row align-items-center">

        {/* LEFT SIDE */}
        <div className="col-lg-6 col-xl-5 ms-xl-auto px-lg-4 text-center text-primary">
          <img
            className="img-fluid mb-4"
            width="350"
            src={imageSchool}
            alt="Forgot password"
          />
          <h1 className="mb-4">
{/*             Réinitialisation du mot de passe
 */}          </h1>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-lg-6 px-lg-4">
          <div className="card shadow-sm">

            <div className="card-header px-lg-5">
              <div className="card-heading text-primary">
                Mot de passe oublié
              </div>
            </div>

            <div className="card-body p-lg-5">

              <p className="text-muted mb-4">
                Entrez votre adresse email pour recevoir un lien de réinitialisation.
              </p>

              {/* SUCCESS MESSAGE */}
              {message && (
                <div className="alert alert-success">
                  {message}
                </div>
              )}

              {/* ERROR MESSAGE */}
              {error && (
                <div className="alert alert-danger">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>

                <div className="form-floating mb-3">
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="name@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <label htmlFor="email">Email</label>
                </div>

                <button
                  className="btn btn-primary w-100"
                  type="submit"
                  disabled={loading || !email}
                >
                  {loading ? "Envoi en cours..." : "Envoyer le lien"}
                </button>

              </form>
            </div>

            <div className="card-footer px-lg-5 py-lg-4 text-center">
              <button
                className="btn btn-link p-0"
                onClick={() => navigate('/login')}
              >
                Retour à la connexion
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default ForgotPassword;